import React from 'react';

const Error = (props) => {
  return (
    // <div className='jumbotron jumbotron-fluid'>
    //   <div className='container text-danger'>
    //     <h3 className='display-2'> Fehler aufgetreten! </h3>
    //     <p className='lead'>{props.message}</p>
    //   </div>
    // </div>
    <div className="alert alert-danger ext-small text-center" id="errorLogin">
    <h4>{props.errorTitle}</h4>
    <p>{props.message}</p>
  </div>
  );
};

export default Error;
